import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import Alert from "@mui/material/Alert";
import Autocomplete from "@mui/material/Autocomplete";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Snackbar from "@mui/material/Snackbar";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import React from "react";
import {useTranslation} from "react-i18next";

import {useNavigate, useParams} from "react-router-dom";
import {useAuth} from "../../context/AuthContext";
import {resetUserPassword, upsertUser} from "../../services/requests/ApiRequests";
import {getOrganizationById, getUser} from "../../services/requests/GraphRequests";
import {validateUserNew} from "../../services/Validations";
import ResetPasswordModal from "./ResetPasswordModal";

const icon = <CheckBoxOutlineBlankIcon fontSize="small"/>;
const checkedIcon = <CheckBoxIcon fontSize="small"/>;

const User = () => {
	const {t} = useTranslation();
	let {userId = ""} = useParams();
	const navigate = useNavigate();

	const currentUser = useAuth()

	const [cashList, setCashList] = React.useState([]);

	const [selOptions, setSelOptions] = React.useState([]);

	const [user, setUser] = React.useState({
		login: '',
		password: '',
		email: '',
		role: '',
		status: 1,
		organization_id: 1,
		cash_register_ids: [],
	});


	React.useEffect(() => {
		if (currentUser?.user?.organizationId) {
			getOrganizationById(currentUser.user.organizationId).then((data) => {
				setCashList(data.data.organization.cashRegisters.filter(item => !!item.number).map(item => ({
					value: item.id + '',
					label: item.number
				})))
			});
		}
	}, [currentUser]);


	React.useEffect(() => {
		if (userId) {
			getUser({id: +userId}).then((data) => {
				const dataUser = data.data.user || {};

				if (!dataUser.id || dataUser.role === 'SUPER_ADMIN' || dataUser.role === 'FISCAL_OFFICER') {
					return;
				}
				setUser(prevState => ({
					...prevState,
					...dataUser,
					password: 0,
					role: dataUser.role === 'ADMIN' ? 1 : 2,
					status: dataUser.status === 'ACTIVE' ? 1 : 2,
				}))
				if (dataUser.cash_register_ids?.length > 0) {
					const selectedCash = cashList.filter(item => dataUser.cash_register_ids.includes(+item.value))
					setSelOptions(selectedCash)
				}
			})
		}

	}, [userId, cashList])

	const [readyToSave, setReadyToSave] = React.useState(false);

	const [formValidationError, setFormValidationError] = React.useState({
		login: true,
		password: true,
		email: true,
		role: true,
		status: true,
		organization_id: true,
		cash_register_ids: true,
	});

	const [success, setSuccess] = React.useState({
		status: false,
		msg: "Error",
	});

	const [error, setError] = React.useState({
		status: false,
		msg: "Error",
	});

	const [openResetPwd, setOpenResetPwd] = React.useState(false);


	React.useEffect(() => {
		let validateResult = validateUserNew({...user, cash_register_ids: selOptions.map(item => item.value)});

		setReadyToSave(validateResult.validation);
		setFormValidationError(validateResult.errors);
	}, [user, selOptions]);


	// React.useEffect(() => {
	// 	if (success) {
	// 		setTimeout(function () {
	// 			navigate("/");
	// 		}, 3500);
	// 	}
	// }, [success]);

	const handleChangePassword = (newPassword) => {
		resetUserPassword({
			user_id: userId,
			new_password: newPassword
		}).then((data) => {
			if (!data.data.success) {
				setError({
					status: true,
					msg: "There are errors while receipt generation",
				});
				return;
			}
			setSuccess({
				status: true,
				msg: "success_reset_pass",
			});
		})
	}

	const handleChange = (event) => {
		setUser(prevState => ({
			...prevState,
			[event.target.name]: event.target.value,
		}));
	};

	const handleClose = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}

		setSuccess({
			status: false,
			msg: "",
		});
		setError({
			status: false,
			msg: "Error",
		});
	};


	function handleUpsertUser() {
		upsertUser({
			...user,
			cash_register_ids: user.role === 1 ? [] : selOptions.map(item => Number(item.value)),
			password: user.password === 0 ? '' : user.password,
		})
			.then((data) => {
				// console.log(data.data);
				if (!data.data.success) {
					setError({
						status: true,
						msg: "There are errors while receipt generation",
					});
					return;
				}
				setSuccess({
					status: true,
					msg: userId ? 'success_update_user' : "success_create_user",
				});
				// window.location.reload();
			})
			.catch((error) => {
				setError({
					status: true,
					msg: `${error}`,
				});
			});
	}

	return (
		<Box
			sx={{flexGrow: 1, marginTop: 3, marginLeft: 10, marginBottom: 10}}
		>
			<Grid container sx={{marginTop: 2}} spacing={4} align="left">
				<Grid item xs={6}>
					<Typography
						sx={{fontSize: 24}}
						color="pimary"
						gutterBottom
					>
						{t(userId ? 'edit_user_title' : 'add_user')}
					</Typography>
					<Button
						variant="text"
						color="secondary"
						onClick={() => {
							navigate(`/users`);
						}}
					>
						&#60; {t('go_back')}
					</Button>
				</Grid>
				<Grid item xs={5} align="right"
				      sx={{display: 'flex', justifyContent: 'flex-end', gap: 1, alignItems: 'center'}}>
					{userId && (
						<Button
							variant="outlined"
							color="secondary"
							onClick={() => setOpenResetPwd(true)}
						>
							{t('reset_password')}
						</Button>
					)}
					<Button
						variant="outlined"
						disabled={!readyToSave}
						onClick={handleUpsertUser}
					>
						{t('save_user')}
					</Button>
				</Grid>

				<Grid container sx={{marginTop: 2}} direction={'row'} spacing={4}>
					<Grid item xs={6} sx={{display: 'flex', flexDirection: 'column', gap: 4, width: '100%'}}>
						<TextField
							error={formValidationError.login}
							name={'login'}
							value={user.login}
							onChange={handleChange}
							variant={"standard"}
							label={t('login')}
							required
							fullWidth
						/>
						<TextField
							error={formValidationError.email}
							name={'email'}
							value={user.email}
							onChange={handleChange}
							variant={"standard"}
							label={t('email')}
							type={'email'}
							required
							fullWidth
						/>
						<FormControl
							error={formValidationError.status} fullWidth>
							<InputLabel variant={'standard'} shrink id="status">{t('status')}</InputLabel>
							<Select
								labelId="status"
								value={user.status}
								onChange={handleChange}
								name={'status'}
								label={t('status')}
								required
								fullWidth
								variant={"standard"}
							>
								<MenuItem value={1}>ACTIVE</MenuItem>
								<MenuItem value={2}>BLOCKED</MenuItem>
							</Select>
						</FormControl>

					</Grid>
					<Grid item xs={6} sx={{display: 'flex', flexDirection: 'column', gap: 4, width: '100%'}}>
						<TextField
							error={formValidationError.password}
							name={'password'}
							value={user.password === 0 ? '' : user.password}
							InputProps={{readOnly: user.password === 0}}
							onChange={handleChange}
							variant={"standard"}
							label={t('password')}
							required
							fullWidth
						/>
						<FormControl fullWidth>
							<InputLabel variant={'standard'} id="role">{t('role')}</InputLabel>
							<Select
								error={formValidationError.role}
								labelId="role"
								value={user.role}
								onChange={handleChange}
								name={'role'}
								label={t('role')}
								required
								fullWidth
								variant={"standard"}
							>
								<MenuItem value={1}>Admin</MenuItem>
								<MenuItem value={2}>Casier</MenuItem>
							</Select>
						</FormControl>

						{user.role === 2 && <Autocomplete
							multiple
							name={'cash_register_ids'}
							value={selOptions}

							error={formValidationError.cash_register_ids}
							limitTags={1}
							onChange={(event, newValue) => {
								setSelOptions(newValue ? newValue : []);
							}}
							options={cashList}
							disableCloseOnSelect
							renderOption={(props, option, {selected}) => {
								const {key, ...optionProps} = props;
								return (
									<li key={key} {...optionProps}>
										<Checkbox
											icon={icon}
											checkedIcon={checkedIcon}
											style={{marginRight: 8}}
											checked={selected}
										/>
										{option.label}
									</li>
								);
							}}
							renderInput={(params) => (
								<TextField
									{...params}
									required
									variant="standard"
									label={'eKassa'}
									placeholder={'eKassa'}
								/>
							)}
						/>}

					</Grid>

				</Grid>
				<Grid item xs={12} align="left" sx={{marginTop: 2}}>
					{t('note_mandatory_fields')}
				</Grid>
			</Grid>
			<Snackbar
				open={success.status}
				autoHideDuration={6000}
				onClose={handleClose}
			>
				<Alert
					onClose={handleClose}
					severity="success"
					sx={{width: "100%"}}
				>
					{success.msg && t(success.msg)}
				</Alert>
			</Snackbar>
			<Snackbar
				open={error.status}
				autoHideDuration={6000}
				onClose={handleClose}
			>
				<Alert
					onClose={handleClose}
					severity="error"
					sx={{width: "100%"}}
				>
					{error.msg}
				</Alert>
			</Snackbar>
			<ResetPasswordModal
				open={openResetPwd}
				onClose={() => setOpenResetPwd(false)}
				userId={userId}
				onSave={handleChangePassword}
				login={user.login}
			/>
		</Box>
	);
}

export default User;
